import { createContext } from 'react';

import type { UTMAttrs } from '@shared/dream-components';

export interface PostPageContextType {
  postId: string;
  canShowCommentsNode: boolean;
  isGatedContentDisabled: boolean;
  onlyRenderComments: boolean;
  isPopupDisabled: boolean;
  hidePremiumComments: boolean;
  showRecommendedPostsNode: boolean;
  showTruncated: boolean;
  isSubscriberGateEnabled: boolean;
  isEmailCapturePopupEnabled: boolean;
  showSubscriberBreak: boolean;
  showPaywallBreak: boolean;
  showPaywallAndHidePostContent: boolean;
  showMeteredUsageBanner: boolean;
  showTextToSpeechBlock: boolean;
  paywallUrl?: string;
  utmParams?: UTMAttrs;
  forcePremium: boolean;
  enforcePaywallBreaks: boolean;
}

export const PostPageContext = createContext<PostPageContextType | undefined>(undefined);
